import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useAuth } from '@/context';
import Loading from './Loading';

/**
 * ProtectedRoute simplificado - verifica apenas autenticacao.
 * Todos os usuarios autenticados tem acesso a todas as rotas.
 */
const ProtectedRoute = ({
  component: Component,
  showLoading = true,
  ...rest
}) => {
  const { user, isLoading } = useAuth();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (isLoading) {
          return showLoading ? <Loading /> : null;
        }

        if (!user) {
          return (
            <Redirect
              to={{
                pathname: '/log_in',
                state: { from: props.location }
              }}
            />
          );
        }

        return <Component {...props} />;
      }}
    />
  );
};

ProtectedRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  showLoading: PropTypes.bool,
  path: PropTypes.string.isRequired,
  exact: PropTypes.bool,
  strict: PropTypes.bool,
  sensitive: PropTypes.bool
};

ProtectedRoute.defaultProps = {
  showLoading: true,
  exact: false,
  strict: false,
  sensitive: false
};

export default ProtectedRoute;
